<template>
  <div :data-ver="$root.content.version">
    <div class="wrapper__parts">
      <a
        :class="{
          wrapper__link: true,
        }"
        v-for="(part, i) in $root.content.parts"
        :key="`part-${i}`"
        :href="part.link"
        @mouseover="mouseoverLink(part.type)"
        @mouseout="mouseoutLink"
        data-tgev="event10"
        data-tgev-metric="ev"
        data-tgev-site="newscomau"
        data-tgev-section="news"
        data-tgev-container= "from-the-newsroom"
        :data-tgev-label="`${part.title}`"
        :data-tgev-order="`${i+1}`"
        data-tgev-content-type="story"
        data-tgev-pagename="from the newsroom podcast"
      >
        <img :src="part.icon" :alt="part.title" />
      </a>
    </div>
  </div>
</template>


<script>
import SimpleTitle from '@/components/headers/simple-title.vue'
import ResponsiveImage from '@/components/responsive-image.vue'

export default {
  name: 'link-block',
  props: [],
  components: {
    SimpleTitle,
    ResponsiveImage,
  },
  mounted () {
    this.initEventTracking();
  },
  methods: {
    mouseoverLink (val) {
      this.hoveredLink = val
    },
    mouseoutLink () {
      this.hoveredLink = null
    },
    getDataAttributes (el) {
      const reDataTrackAttr = /^data-tgev-/;
      let data = {};
      [].forEach.call(el.attributes, function(attr) {
        if (reDataTrackAttr.test(attr.name)) {
          var attrName = attr.name.replace(reDataTrackAttr, '');
          data[attrName] = attr.value;
        }
      });
      return data;
    },
    sendAnalytics (metricType, metricObj ) {
      // console.log(arguments);

      if (typeof metricType === 'undefined') {
        return;
      }

      window.mready = window.mready || [];
      window.mready.push( function (metrics) {
        metrics[metricType](metricObj);
      });
    },
    initEventTracking () {
      const ref=this
      document.querySelector('.dna-custom-app').addEventListener('click', function (event) {
        const clickedEl = event.target.parentElement; // get the anchor around the image
        // console.log('clickedEl', clickedEl)
        const trackEvent = clickedEl.getAttribute('data-tgev');
        // console.log('trackEvent', trackEvent)
        if (trackEvent && trackEvent.length) {
          const attributes = ref.getDataAttributes(clickedEl);
          // console.log('attributes',attributes)
          if (attributes && attributes.social) {
            ref.sendAnalytics(attributes.metric, {
              events: [trackEvent],
              eVar27: attributes.social
            });
          }

          if (attributes && attributes.order) {
            ref.sendAnalytics(attributes.metric, {
              events: [trackEvent],
              itm: {
                order: attributes.order,
                container: attributes.container,
                label: attributes.label,
                site: attributes.site,
                section: attributes.section,
                content_type: attributes['content-type'],
                pagename: attributes.pagename,
              }
            });
          }
        }
      });
    },
  },
  computed: {
    
  },
}
</script>

<style scoped lang="sass">
@import index

.wrapper
  &__header
    margin: 0 auto 32px auto
    align-items: flex-start
    border-radius: 12px
    overflow: hidden
    background: radial-gradient(#f0f0f0, #d0d0d0)
    img
      position: relative
      margin: 24px auto
      max-width: 450px
      width: 80%
  &__message
    background: #737d81
    padding: 8px
    p
      font-family: 'Arial'
      text-align: center
      color: white
      font-weight: 400
      font-size: 16px
      @media screen and(min-width: 500px)
        font-size: 20px
  &__headerImage
    img
      max-width: 400px
  &__parts
    text-align: center
  &__link
    display: inline-block
    transition: all 200ms
    position: relative
    padding: 8px 14px
    margin: 4px
    text-decoration: none
    border-radius: 4px
    box-shadow: none
    background: black
    border: solid 2px $color-grey-4
    border-radius: 12px
    &:hover
      transform: translate(0, -8px)
      +shadow-box-2
    img
      display: block
      width: auto
      margin: 0 auto
      height: 30px
      @media screen and (min-width: 500px)
        height: 35px
    &:visited
      border-color: none
      &:last-of-type
        margin-bottom: auto

p.intro
  font-size: 16px
  line-height: 20px
  margin-bottom: 24px !important

</style>



// WEBPACK FOOTER //
// src/layouts/link-block.vue